import { Metamodel } from 'app/model/base/model';
import { FormatReadSettings } from './format-read-settings';
import { ParquetDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.parquet.formatRead,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(ParquetDataset) }
})
export class ParquetFormatReadSettings extends FormatReadSettings {}
